/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";
import Card from "../../component/card/Card";
import Strong from "../../component/smallComponents/Strong";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import TextInput from "../../component/input/TextInput";
import SelectInput from "../../component/input/SelectInput";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Button from "../../component/button/Button";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const UserEdit = ({
  onEditUser,
  showOptions,
  department,
  designation,
  editLoading,
  editUserDetail,
  allLocations,
  currentUser,
  lastLocationId,
  setLastLocationId,
  handleInputChange,
  handleSelectManagers,
  reportingIds,
  reportingManagers
}) => {
  return (
    <div className="row mt-2">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <Card>
          <div className="row mb-2">
            <div className="col-lg-12">
              <Strong
                title="All inputs mark with * are compulsory"
                className="text-danger float-right"
              />
              <HeaderTag
                type="h4"
                title="Edit User by Below form"
                isClassName={false}
              />
            </div>
          </div>
          <form className="" onSubmit={onEditUser}>
            <div className="row">
              <div className="col-md-3 mb-3">
                <TextInput
                  type="text"
                  required={true}
                  textWhite={false}
                  name="workerFirstName"
                  label="First Name"
                  htmlFor="workerFirstName"
                  onChange={handleInputChange}
                  placeholder="Enter First Name"
                  value={editUserDetail.workerFirstName}
                />
              </div>
              <div className="col-md-3 mb-3">
                <TextInput
                  type="text"
                  required={true}
                  textWhite={false}
                  name="workerSurname"
                  label="Surname"
                  htmlFor="workerSurname"
                  placeholder="Enter Surname"
                  onChange={handleInputChange}
                  value={editUserDetail.workerSurname}
                />
              </div>
              <div className="col-md-3 mb-3">
                <TextInput
                  type="number"
                  required={true}
                  textWhite={false}
                  name="workerPhoneNumber"
                  label="Phone Number"
                  htmlFor="workerPhoneNumber"
                  onChange={handleInputChange}
                  placeholder="Enter Phone Number"
                  value={editUserDetail.workerPhoneNumber}
                />
              </div>
              <div className="col-md-3 mb-3">
                <SelectInput
                  required={true}
                  isLabeled={true}
                  textWhite={false}
                  name="workerType"
                  label="Select Type"
                  value={editUserDetail.workerType}
                  onChange={handleInputChange}
                >
                  {showOptions}
                </SelectInput>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 mb-4">
                <SelectInput
                  required={true}
                  isLabeled={true}
                  textWhite={false}
                  name="designationId"
                  htmlFor="designationId"
                  label="Select Designation"
                  onChange={handleInputChange}
                  value={editUserDetail.designationId}
                >
                  {designation.map((designationName, index) => (
                    <option value={designationName._id} key={index}>
                      {designationName.designationName}
                    </option>
                  ))}
                </SelectInput>
              </div>
              <div className="col-md-4 mb-4">
                <SelectInput
                  required={true}
                  isLabeled={true}
                  textWhite={false}
                  name="departmentId"
                  htmlFor="departmentId"
                  label="Select Department"
                  onChange={handleInputChange}
                  value={editUserDetail.departmentId}
                >
                  {department.map((departmentName, index) => (
                    <option value={departmentName._id} key={index}>
                      {departmentName.departmentName}
                    </option>
                  ))}
                </SelectInput>
              </div>
              <div className="col-md-4 mb-4">
                <TextInput
                  type="email"
                  required={true}
                  textWhite={false}
                  name="workerEmail"
                  htmlFor="workerEmail"
                  label="Email Id"
                  onChange={handleInputChange}
                  placeholder="Enter Email Id"
                  value={editUserDetail.workerEmail}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-2 mb-2">
                <TextInput
                  type="text"
                  required={true}
                  name="workerId"
                  disabled={true}
                  textWhite={false}
                  htmlFor="workerId"
                  label="Employee Id"
                  onChange={handleInputChange}
                  placeholder="Enter Employee Id"
                  value={editUserDetail.workerId}
                />
              </div>
              <div className="col-md-3 mb-3">
                <TextInput
                  type="text"
                  required={true}
                  disabled={true}
                  textWhite={false}
                  name="locationName"
                  htmlFor="locationName"
                  label="Location Name"
                  onChange={handleInputChange}
                  placeholder="Enter Location Name"
                  value={editUserDetail.locationName}
                />
              </div>

              <div className="col-md-3 mb-3">
                <TextInput
                  type="text"
                  required={true}
                  disabled={true}
                  textWhite={false}
                  label="Aadhar Card Number"
                  onChange={handleInputChange}
                  name="workerAadharCardNumber"
                  htmlFor="workerAadharCardNumber"
                  placeholder="Enter Phone Number"
                  value={editUserDetail.workerAadharCardNumber}
                />
              </div>
              <div className="col-md-4 mb-3 mt-3">
                <Select
                  isMulti
                  name="reportingIds"
                  options={reportingManagers}
                  value={reportingIds}
                  classNamePrefix="select"
                  className="basic-multi-select"
                  placeholder={"Select More Filters And Get Data"}
                  onChange={handleSelectManagers}
                />
              </div>
              <div className="col-md-3 mb-3">
                <SelectInput
                  required={true}
                  textWhite={false}
                  isLabeled={false}
                  name="lastLocationId"
                  value={lastLocationId}
                  label="Select Location To Change"
                  onChange={(e) => setLastLocationId(e.target.value)}
                >
                  <option value=""> Select Location</option>
                  {isSuperAdmin(currentUser)
                    ? renderLocationFunction(allLocations)
                    : renderAccessLocation2(
                        locationRender(currentUser, false)
                      )}
                </SelectInput>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 mb-3"></div>
              <div className="col-md-2 mb-2"></div>
              <div className="col-md-2 mb-2">
                {editLoading ? (
                  <SpinnerButton />
                ) : (
                  <Button
                    type="submit"
                    title="Submit"
                    isBackgroundColor={false}
                    icon="mdi mdi-plus-circle-outline mr-2"
                    className="btn mb-2 text-white btn-dark"
                  />
                )}
              </div>
              <div className="col-md-3 mb-3"></div>
              <div className="col-md-2 mb-2"></div>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

UserEdit.propTypes = {
  currentUser: PropTypes.object,
  showOptions: PropTypes.any.isRequired,
  onEditUser: PropTypes.func.isRequired,
  editLoading: PropTypes.bool.isRequired,
  department: PropTypes.array.isRequired,
  designation: PropTypes.array.isRequired,
  allLocations: PropTypes.array.isRequired,
  lastLocationId: PropTypes.string.isRequired,
  editUserDetail: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  setLastLocationId: PropTypes.func.isRequired,
  handleSelectManagers: PropTypes.func.isRequired,
  reportingIds: PropTypes.array.isRequired,
  reportingManagers: PropTypes.array.isRequired
};

export default UserEdit;
